export const setCSSProperty = (element, prop, val) =>
  document.querySelector(element).style.setProperty(`--${prop}`, val);
